import gql from 'graphql-tag';

// Log user in
export const MUTATION_LOGIN = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        account_id
        id
        role
      }
    }
  }
`;

// Create a new user record
export const MUTATION_SIGN_UP = gql`
  mutation signup(
    $email: String!
    $firstName: String!
    $lastName: String!
    $nonce: String!
    $password: String!
    $phone_number: String!
    $voyyp_phone_number: String!
  ) {
    signup(
      braintree_nonce: $nonce
      email: $email
      first_name: $firstName
      last_name: $lastName
      password: $password
      phone_number: $phone_number
      voyyp_phone_number: $voyyp_phone_number
    ) {
      token
      user {
        account_id
        id
        role
      }
    }
  }
`;
